// extracted by mini-css-extract-plugin
export var deleteModal = "_hv-0";